import {
  appendSignature,
  removeSignature,
} from 'dashboard/helper/editorHelper';

const normalizeNewlines = value => String(value || '').replace(/\r\n?/g, '\n');

export const signatureForChannel = (signature, channelType) => {
  if (!signature) return '';

  const appended = appendSignature('', signature, channelType);
  return normalizeNewlines(appended)
    .replace(/^\s*--\s*\n+/, '')
    .trim();
};

export const removeSignatureFromEditor = ({
  body = '',
  signature = '',
  channelType,
}) => {
  if (!signature) return normalizeNewlines(body);

  const canonicalSignature = signatureForChannel(signature, channelType);
  let cleanedBody = normalizeNewlines(
    removeSignature(body, signature, channelType)
  ).trim();

  if (!canonicalSignature) return cleanedBody;

  const topCandidates = [
    canonicalSignature,
    `--\n\n${canonicalSignature}`,
  ];

  topCandidates.forEach(candidate => {
    if (cleanedBody === candidate) {
      cleanedBody = '';
      return;
    }

    if (cleanedBody.startsWith(`${candidate}\n`)) {
      cleanedBody = cleanedBody.slice(candidate.length).replace(/^\n+/, '');
    }
  });

  return normalizeNewlines(
    removeSignature(cleanedBody, signature, channelType)
  ).trim();
};

export const messageWithSignatureAtTop = ({
  body = '',
  signature = '',
  enabled = false,
  channelType,
}) => {
  if (!enabled) return normalizeNewlines(body);

  const cleanBody = removeSignatureFromEditor({
    body,
    signature,
    channelType,
  });

  if (!cleanBody) return cleanBody;

  const canonicalSignature = signatureForChannel(signature, channelType);
  if (!canonicalSignature) return cleanBody;

  return `${canonicalSignature}\n${cleanBody}`;
};

const isTemplatePayload = payload =>
  Boolean(
    payload?.template_params ||
      payload?.message?.template_params ||
      payload?.additional_attributes?.template_params
  );

export const payloadWithSignatureAtTop = ({
  payload,
  signature = '',
  enabled = false,
  channelType,
}) => {
  if (!payload || payload.private || isTemplatePayload(payload)) return payload;

  const sign = body =>
    messageWithSignatureAtTop({
      body,
      signature,
      enabled,
      channelType,
    });

  if (typeof payload.content === 'string') {
    return { ...payload, content: sign(payload.content) };
  }

  if (typeof payload.message === 'string') {
    return { ...payload, message: sign(payload.message) };
  }

  if (payload.message && typeof payload.message.content === 'string') {
    return {
      ...payload,
      message: {
        ...payload.message,
        content: sign(payload.message.content),
      },
    };
  }

  return payload;
};
